import React from 'react';
import { motion } from 'framer-motion';
export function DiagnosisSection() {
  const problems = [{
    number: '01',
    title: 'El lead de Zillow ya habló con tu competencia.',
    desc: 'Cuando compras un lead de portal, ese mismo lead fue vendido a 3 o 5 agentes más. El primero que llama gana. Y si no eres el primero en 2 minutos, ya perdiste la transacción.'
  }, {
    number: '02',
    title: 'No estás construyendo tu marca personal.',
    desc: 'En Real Estate, la gente no contrata a una agencia. Contrata a UNA persona. Si no tienes una marca personal de alta autoridad digital, eres intercambiable. Y lo intercambiable se elige por precio.'
  }, {
    number: '03',
    title: 'Tu base de datos de clientes pasados vale una fortuna que no estás cobrando.',
    desc: 'El 89% de los compradores dicen que usarían a su agente nuevamente. Pero solo el 12% lo hace. ¿Por qué? Porque el agente no tiene sistema de seguimiento.'
  }];
  return <section className="py-20 md:py-24 px-5 md:px-8 bg-dark-300 border-y border-dark-100" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-gold tracking-tight" data-id="element-4">
            El Diagnóstico
          </h2>
          <div className="w-16 md:w-24 h-1 bg-gold/20 mx-auto mt-6 rounded-full" data-id="element-5" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-6">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-dark-200 border border-dark-100 p-6 md:p-8 rounded-lg hover:border-dark-100/80 transition-colors flex flex-col" data-id="element-7">
              <span className="text-4xl md:text-5xl font-black text-gold/10 block mb-4 md:mb-6" data-id="element-8">
                {problem.number}
              </span>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4 leading-snug" data-id="element-9">
                {problem.title}
              </h3>
              <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-10">
                {problem.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}